import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { CreateNoteInput } from "@acto/gql/graphql";
import { useCallback, useState } from "react";

const CreateNoteMutation = graphql(`
  mutation CreateNote($input: CreateNoteInput!) {
    createNote(input: $input) {
      id
      clientId
      meetingId
      content
      title
      createdAt
      updatedAt
      summary
      openTodosCount
      __typename
    }
  }
`);

export function useCreateNote() {
  const [result, createNoteMutation] = useMutation(CreateNoteMutation);
  const [error, setError] = useState<Error | null>(null);

  const createNote = useCallback(
    async (input: CreateNoteInput) => {
      try {
        const response = await createNoteMutation({ input });
        if (response.error) {
          throw response.error;
        }
        return response.data?.createNote;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [createNoteMutation],
  );

  return { createNote, result, error };
}
